import React, { Suspense, ComponentType } from 'react';
import Spinner from './Spinner';

const WithSuspense = <P extends object>(Component: ComponentType<P>) => {
  const WrappedComponent: React.FC<P> = (props: P) => (
    <Suspense fallback={<Spinner />}>
      <Component {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `WithSuspense(${
    Component.displayName || Component.name || 'Component'
  })`;

  return WrappedComponent;
};

export default WithSuspense;
